import React, { Component } from "react";
import SlidingPane from "react-sliding-pane";
import moment from "moment";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { Icon, Button } from "../../common";
import styles from "./DisputeModal.scss";

const SalesModal = props => {
  const {
    isPaneOpen,
    onRequestClose,
    currencyCode,
    item,
    asn = "AQWEEWRW"
  } = props;

  return (
    <div>
      <SlidingPane
        isOpen={isPaneOpen}
        onRequestClose={onRequestClose}
        className={styles.panelClass}
        overlayClassName={styles.overlayPaneClass}
      >
        <div className={styles.offerModalInner}>
          <div className={styles.header}>
            <h4>{I18n.getText("transfers.dispute-summary")}</h4>
            <div onClick={onRequestClose}>
              <Icon name="close" />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.eachInput}>
              <label className={styles.label}>
                {I18n.getText("offer.p-sku")}
              </label>
              <div className={styles.val}>
                {asn}
                <Button className={styles.btnCtr} variant="transparent">
                  <Icon name="print" />
                </Button>
                <Button className={styles.btnCtr} variant="transparent">
                  <Icon name="download" />
                </Button>
              </div>
            </div>
            <div className={styles.eachInput}>
              <label className={styles.label}>
                {I18n.getText("transfers.comments")}
              </label>
              <div className={styles.val}>
                <textarea
                  rows="6"
                  className={styles.textArea}
                  name="dispute_comment"
                />
              </div>
            </div>
            <div className={styles.eachInput}>
              <Button className={styles.btns}>
                {I18n.getText("products.submit")}
              </Button>
              <Button
                className={styles.btns}
                variant="transparent"
                onClick={onRequestClose}
              >
                {I18n.getText("transfers.cancel")}
              </Button>
            </div>
          </div>
        </div>
      </SlidingPane>
    </div>
  );
};

export default SalesModal;



// WEBPACK FOOTER //
// ./src/components/transfers/disputeModal/DisputeModal.js